// Google OAuth web client IDs are public identifiers — they are rendered into
// every signed-in user's page, embedded in the OAuth popup URL, and shipped
// inside the JS bundle. They are NOT secrets. We hardcode the value as a
// fallback so any build that forgets to inject VITE_GOOGLE_CLIENT_ID still
// produces a working sign-in flow. Override via env when testing against a
// different Google project.
const DEFAULT_GOOGLE_CLIENT_ID =
  '530563197525-eemk8qttr9obisu286ae50avqe5k43nd.apps.googleusercontent.com';

export function resolveGoogleClientId(
  envValue: string | undefined = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined,
): string {
  const trimmed = envValue?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : DEFAULT_GOOGLE_CLIENT_ID;
}

export const GOOGLE_CLIENT_ID = resolveGoogleClientId();
